import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from '../utils/api';
import { FaCheckCircle } from 'react-icons/fa';
import './InquiryForm.css';

const InquiryForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    mobile: '',
    email: '',
    city: '',
    insuranceType: '',
    vehicleType: '',
    policyNumber: '',
    message: '',
    documents: null
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const insuranceTypes = [
    'Car Insurance',
    'Bike Insurance',
    'Health Insurance',
    'Commercial Insurance',
    'Travel Insurance'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'email' ? value.toLowerCase() : value
    });
  };

  const handleMobileChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    const trimmedValue = rawValue.startsWith('91') ? rawValue.slice(2) : rawValue;
    const limitedValue = trimmedValue.slice(0, 10);
    setFormData({
      ...formData,
      mobile: limitedValue
    });
  };

  const handleDocumentUpload = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    setFormData({
      ...formData,
      documents: file
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/inquiries/create', {
        ...formData,
        timestamp: new Date().toISOString()
      });

      if (response.data.success) {
        setSubmitted(true);
        toast.success('Inquiry submitted successfully!');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to submit inquiry. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="inquiry-page">
        <div className="thank-you-section">
          <div className="container">
            <div className="thank-you-card card">
              <FaCheckCircle className="success-icon" />
              <h1>Thank You!</h1>
              <p>Your insurance inquiry has been submitted successfully.</p>
              <p>Our team will contact you shortly to assist you with your insurance needs.</p>
              <button onClick={() => navigate('/')} className="btn btn-primary">
                Return to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="inquiry-page">
      <div className="inquiry-hero">
        <div className="container">
          <h1 className="page-title">Get Insurance Quote</h1>
          <p className="page-subtitle">Fill in your details and we'll get back to you</p>
        </div>
      </div>

      <section className="inquiry-section">
        <div className="container">
          <div className="inquiry-form-wrapper card">
            <h2>Insurance Inquiry Form</h2>
            <form onSubmit={handleSubmit} className="inquiry-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    className="form-input"
                    value={formData.fullName}
                    onChange={handleChange}
                    style={{ textTransform: 'capitalize' }}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Mobile Number *</label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-input"
                    value={`+91 ${formData.mobile}`}
                    onChange={handleMobileChange}
                    maxLength={15}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    value={formData.email}
                    onChange={handleChange}
                    style={{ textTransform: 'lowercase' }}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">City *</label>
                  <input
                    type="text"
                    name="city"
                    className="form-input"
                    value={formData.city}
                    onChange={handleChange}
                    style={{ textTransform: 'capitalize' }}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Insurance Type *</label>
                  <select
                    name="insuranceType"
                    className="form-select"
                    value={formData.insuranceType}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Insurance Type</option>
                    {insuranceTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label">Vehicle Type</label>
                  <input
                    type="text"
                    name="vehicleType"
                    className="form-input"
                    value={formData.vehicleType}
                    onChange={handleChange}
                    style={{ textTransform: 'capitalize' }}
                    placeholder="e.g., Sedan, SUV, Hatchback"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Policy Number</label>
                  <input
                    type="text"
                    name="policyNumber"
                    className="form-input"
                    value={formData.policyNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Upload Docs</label>
                  <input type="file" name="documents" className="form-input" onChange={handleDocumentUpload} />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea
                  name="message"
                  className="form-textarea"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  style={{ textTransform: 'capitalize' }}
                  placeholder="Any additional information or requirements..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-large" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Inquiry'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InquiryForm;


